document.addEventListener("DOMContentLoaded", function() {
	let mouseEnterTimeout, mouseLeaveTimeout;
	const hoverIntentTimeout =  300;

	function addBackDropElement() {
		if(document.querySelector('#main-nav .nav-item.has-mega-menu.level-2')) {
			const div = document.createElement("div");
			div.className = "menu-overlay-backdrop";
			document.body.insertBefore(div, document.body.firstChild);
		}
	}

	function mouseEnterCallback(target) {
		clearTimeout(mouseLeaveTimeout);

		mouseEnterTimeout = setTimeout(() => {
			const currentMegaMenuContainer = target.querySelector('.mega-menu-container');
			const allMegaMenuContainers = document.querySelectorAll('#main-nav .mega-menu-container');

			if(!currentMegaMenuContainer || allMegaMenuContainers.length === 0) {
				return;
			}

			allMegaMenuContainers.forEach(item => item.classList.remove('show'));
			currentMegaMenuContainer.classList.add('show');
		}, hoverIntentTimeout);
	}

	function mouseLeaveCallback() {
		clearTimeout(mouseEnterTimeout);

		mouseLeaveTimeout = setTimeout(() => {
			const allMegaMenuContainers = document.querySelectorAll('#main-nav .mega-menu-container');

			if (allMegaMenuContainers.length === 0) {
				return;
			}

			allMegaMenuContainers.forEach(item => item.classList.remove('show'));
		}, hoverIntentTimeout);
	}

	function handleSpaceBarKeyPress(event) {
		event.preventDefault();
		const megaMenuNavItem = event.target.classList.contains('is-parent-link') 
			? event.target.closest('li.has-mega-menu') 
			: event.target;

		const currentMegaMenuContainer = megaMenuNavItem.querySelector('.mega-menu-container');

		if (!currentMegaMenuContainer) {
			return;
		}

		if(currentMegaMenuContainer.classList.contains('show')) {
			mouseLeaveCallback();
		} else {
			mouseEnterCallback(megaMenuNavItem);
		}
	}

	addBackDropElement();

	const navItemList = document.querySelectorAll('#main-nav .nav-item.has-mega-menu');

	if(!navItemList) {
		return;
	}

	navItemList.forEach(linkItem => {
		linkItem.addEventListener("mouseenter", (e) => mouseEnterCallback(e.target));
		linkItem.addEventListener("mouseleave", mouseLeaveCallback);
		linkItem.addEventListener("keydown", (e) => {
			if (e.code === 'Space' || e.keyCode === 32) {
				handleSpaceBarKeyPress(e);
			}
		});
	});
});

